import React from 'react'
import { useTranslation } from 'react-i18next'

import { PerksSignupComponentKey, RoutesMapping, SectionType } from 'adminSignUp'

import { CompanyAddressValues } from 'core/application/adminSignUp/common/models'
import perksCompanyAddressApi from 'core/application/adminSignUp/perks/companyAddress'
import { ProductIds } from 'core/application/commons/config'

import { BaseNavigationProps } from '../../../common/wizard/BaseNavigationProps'
import CompanyAddress from '../../common/CompanyAddress'

const PerksCompanyAddress: React.FC<BaseNavigationProps<CompanyAddressValues>> = (props) => {
  const { t: translate } = useTranslation()

  const Steps = RoutesMapping.get(ProductIds.Perks).filter((i) => i.sectionType === SectionType.COMPANY_DETAILS)

  return (
    <CompanyAddress
      onSubmitFormHandler={(values) => perksCompanyAddressApi(values)}
      message={''}
      description={translate('admin-signup.company-details.company-address.perks-alert-description')}
      numberOfQuestions={Steps.length}
      currentQuestion={Steps.findIndex((i) => i.key === PerksSignupComponentKey.COMPANY_PHONE_NUMBER) + 1}
      {...props}
    />
  )
}

export default PerksCompanyAddress
